import { Card, CardContent } from "@components/common/card";
import useTranslator from "@pma/hooks/use-translator";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@components/common/tabs";
import { cn } from "@pma/utils/helpers";
import { ApprovalBoQDetails } from "./approval-boq-items";
import { SignBoQItemDetails } from "./sign-boq-request-items";
import { useAuth } from "@pma/stores/auth-store";
import { DictType } from "@pma/types";
import { useEffect } from "react";

interface Props {
  boqId: string;
}

export function ItemRequestDetails({ boqId }: Props) {
  const { authConfig, setTabManager } = useAuth();
  const { translate, locale } = useTranslator();

  const isHebrew = locale === "he";

  const allStateTabs = authConfig?.tabs ?? {};
  const mainBoQActiveTab = allStateTabs ? allStateTabs["main-boq"] : undefined;
  const activeTabs: DictType = mainBoQActiveTab || {
    main: "item-requests",
    sub: "approval",
  };

  useEffect(() => {}, [activeTabs?.sub]);
  return (
    <div className='space-y-6'>
      <Card className='w-full space-y-6 overflow-x-hidden border-none shadow-none'>
        <CardContent className='p-2 md:p-4'>
          <Tabs
            defaultValue={"main-boq-item-requests"}
            className={cn("relative w-full max-w-[90vw] overflow-x-auto", isHebrew ? "rtl" : "ltr")}
          >
            <TabsList className='flex w-full items-center justify-center bg-transparent'>
              <TabsTrigger
                value='approval'
                className={cn(
                  "rounded-none border-primary bg-transparent data-[state=active]:border-b-2 data-[state=active]:bg-transparent data-[state=active]:shadow-none",
                  activeTabs?.sub === "approval" && "border-b-2",
                )}
                defaultChecked={activeTabs?.sub === "approval"}
                onClick={() => {
                  setTabManager({
                    group: "main-boq",
                    main: "item-requests",
                    sub: "approval",
                  });
                }}
              >
                {translate("Approval")}
              </TabsTrigger>
              <TabsTrigger
                value='for-sign'
                className={cn(
                  "rounded-none border-primary bg-transparent data-[state=active]:border-b-2 data-[state=active]:bg-transparent data-[state=active]:shadow-none",
                  activeTabs?.sub === "for-sign" && "border-b-2",
                )}
                onClick={() => {
                  setTabManager({
                    group: "main-boq",
                    main: "item-requests",
                    sub: "for-sign",
                  });
                }}
              >
                {translate("Sign")}
              </TabsTrigger>
            </TabsList>
            <TabsContent forceMount value={"main-boq-item-requests"} className={cn("p-0")}>
              {activeTabs?.sub === "for-sign" && <SignBoQItemDetails boqId={boqId} />}
              {activeTabs?.sub === "approval" && <ApprovalBoQDetails boqId={boqId} />}
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
}
